let UTILS = require("../libs/utils.js");
var v7730;
var v7731;
module.exports = {
  id: "kc",
  name: "Kill Confirmed",
  alias: "kc",
  endStats: ["sid", "name", "score", "kills", "deaths", "confirms", "denies", "reward"],
  leaderStats: ["confirms", "score", "denies"],
  leaderSort: function (p9186, p9187) {
    if (p9186.confirms === p9187.confirms && p9186.kills && p9187.kills) {
      return p9186.kills - p9187.kills;
    } else {
      return p9187.confirms - p9186.confirms;
    }
  },
  endSort: function (p9188, p9189) {
    if (p9188.confirms === p9189.confirms && p9188.kills && p9189.kills) {
      return p9189.kills - p9188.kills;
    } else {
      return p9189.confirms - p9188.confirms;
    }
  },
  winCondition: function (game) {
    var v7732 = game.teamScores[1] || 0;
    var v7733 = game.teamScores[2] || 0;
    if (v7732 == v7733) {
      var vLN01220 = 0;
      var vLN01221 = 0;
      var vLN01222 = 0;
      var vLN01223 = 0;
      var vLN01224 = 0;
      var vLN01225 = 0;
      for (var vLN01226 = 0; vLN01226 < game.players.list.length; ++vLN01226) {
        var v7734 = game.players.list[vLN01226].kills;
        var v7735 = game.players.list[vLN01226].score;
        var v7736 = game.players.list[vLN01226].denies;
        if (game.players.list[vLN01226].team == 1) {
          vLN01222 += v7734;
          vLN01220 += v7735;
          vLN01224 += v7736;
        } else {
          vLN01223 += v7734;
          vLN01221 += v7734;
          vLN01225 += v7736;
        }
      }
      if (vLN01224 == vLN01225) {
        if (vLN01222 == vLN01223) {
          if (vLN01220 > vLN01221) {
            return 1;
          } else {
            return 2;
          }
        } else if (vLN01222 > vLN01223) {
          return 1;
        } else {
          return 2;
        }
      } else if (vLN01224 > vLN01225) {
        return 1;
      } else {
        return 2;
      }
    }
    if (v7732 > v7733) {
      return 1;
    } else {
      return 2;
    }
  },
  condition: [function (p9191) {
    var v7737 = p9191.teamScores[1] || 0;
    var v7738 = p9191.teamScores[2] || 0;
    return !(v7737 >= p9191.mode.tagLimit) && !(v7738 >= p9191.mode.tagLimit);
  }],
  onKill: function (p9192, p9193, p9194) {
    p9192.dropSpawnable(0, p9194);
  },
  tagLimit: 65,
  teams: true,
  noScoreC: true
};